import _set from 'lodash/set';

export function setUIValueToSdkData<T extends object>(
    sdkData: T,
    sdkDataKey: keyof T,
    uiDataVal,
    isComplexType = true,
) {
    if (uiDataVal !== undefined) {
        if (uiDataVal === null) {
            _set(sdkData, sdkDataKey, uiDataVal);
        } else {
            _set(sdkData, `${sdkDataKey as string}${isComplexType ? '.val' : ''}`, uiDataVal);
        }
    }
}
